import { Injectable, Inject, signal } from '@angular/core';
import { SsoOptions } from './sso-options';

@Injectable()
export class SsoOptionsService {
  private readonly _options: SsoOptions;
  /**
   * Stores and serves redirection flag.
   * Defined on SsoOptionsService due to issue with multiple interceptor instances.
   */
  private readonly _alreadyRedirected = signal(false);

  constructor(@Inject('SsoOptions') private ssoOptions: SsoOptions) {
    this._options = this.ssoOptions;
  }

  get options() {
    return this._options;
  }

  get alreadyRedirected() {
    return this._alreadyRedirected();
  }

  set alreadyRedirected(val: boolean) {
    this._alreadyRedirected.set(val);
  }
}
